export const getSrcElementInputPack = (event) => {
  const { clientX, clientY, srcElement } = event;
  const { left, top, width, height } = srcElement.getBoundingClientRect();
  const x = clientX - left;
  const y = clientY - top;
  const percentX = x / width;
  const percentY = y / height;
  const parentElement = srcElement.parentElement;
  return {
    x,
    y,
    percentX,
    percentY,
    parentElement,
  };
};
